import '../Home_css/Product.css';
import Products_Page_Bed from '../../Assets/Dahlia_images/produc/cropped_products01.webp';
// import Products_Page_Bed from '../../Assets/Website_Images_2/Products_Bed.jpg'
import Products_Page_pads from '../../Assets/Dahlia_images/produc/cropped_products02.webp';
import 'bootstrap/dist/css/bootstrap.css';
import { Container, Card,  } from 'react-bootstrap';





const About = () =>{
  

return(
 <section id="Products" className='Products' >
 
 
  <Container>
  <div className="about_title">
    <div>
      <h1>Explore Our<br/> Products</h1>
    </div>
  </div>
  </Container>
<Container>
<div className="row g-3">

   <div className='Products col-md-6 d-flex align-items-stretch'>  
  <Card>  
  <Card.Img variant="top" src={Products_Page_Bed} alt='beds'/>  
  <Card.Body>  
    <Card.Title>
      
      <div className="d-flex justify-content-between align-items-center">
  <h5 className="text-end">PINNACLE BED </h5>
  <a 
    href="https://link.dahliahealth.com/widget/booking/gd1QJvU7rEkI6bAqYkCm" 
    className="get-btn"
  >
    Get Started
  </a>
</div>
      <p>As low as $1,200/Month* <br/>or $59,990</p>
      
      </Card.Title>  
    <Card.Text> 
      <ul>
    <li> Full Body Treatments</li>
    <li > 16 SmartSegmentsTM </li>
    <li> 5 PrescriptiveTreatmentTM Protocols</li>
    <li> Advanced Patent Pending Tech Package </li>
    <li> 12 to 15 Minute Treatment Times</li>
    <li> Zero Gravity Comfort </li>
    <li> Low Staff / Self Serve</li>
    </ul> 
    </Card.Text>  
    {/* <Button variant="primary">Get Started</Button>   */}
  </Card.Body>  
</Card> 
</div>  
    
{/* second card */}


   <div className='Products col-md-6 d-flex align-items-stretch'>  
  <Card>  
   <Card.Img variant="top" src={Products_Page_pads}alt='pads' />   
  <Card.Body>  
    <Card.Title>
    <div className="d-flex justify-content-between align-items-center">
  <h5 className="text-end">SUMMIT PADS</h5>
  <a 
    href="https://link.dahliahealth.com/widget/booking/gd1QJvU7rEkI6bAqYkCm" 
    className="get-btn"
  >
    Get Started
  </a>
</div>

    <p>As low as $650/Month* <br/>or $29,990</p>
   
      </Card.Title>  
    <Card.Text> 
   <ul>
   <li> Focused Treatment Areas </li>
   <li> 8 Durable SmartSegmentsTM Learn More</li>
   <li> 5 PrescriptiveTreatmentTM Protocols</li>
   <li> Advanced Patent Pending Tech Package</li>
   <li> 20 Minute Treatment Times</li>
   </ul>
    </Card.Text>  
    
  </Card.Body>  
</Card>   
</div>  

</div>
</Container>

<Container>
<div className='about_desc'>
  <p className="about_us_footer">*Dahlia Health partners with lenders that represent over 40 banks and lending organizations. While Dahlia receives no compensation for recommending these lenders, you may find it easier to start with them since they understand our workflow. We encourage you to find the best deal for your situation. Credit and Selected Term impact monthly payments. All terms are subject to approval by individual lenders and may change without notice.</p>
</div>

</Container>


</section>
 
 
);


}

export default About;

